import React from "react";

import { ReactComponent as BuildingIcon } from "../../../assets/images/empresarial/building.svg";
import { ReactComponent as TrophyIcon } from "../../../assets/images/empresarial/trophy.svg";
import { ReactComponent as PinIcon } from "../../../assets/images/empresarial/pin.svg";
import { ReactComponent as ExplosionIcon } from "../../../assets/images/empresarial/explosion.svg";
import { ReactComponent as CautionIcon } from "../../../assets/images/empresarial/caution.svg";
import { ReactComponent as TheftIcon } from "../../../assets/images/empresarial/theft.svg";
import { ReactComponent as StrikeIcon } from "../../../assets/images/empresarial/strike.svg";
import { ReactComponent as RiotIcon } from "../../../assets/images/empresarial/riot.svg";
import { ReactComponent as GlassIcon } from "../../../assets/images/empresarial/glass.svg";
import { ReactComponent as MoneyIcon } from "../../../assets/images/empresarial/money.svg";
import { ReactComponent as NotebookIcon } from "../../../assets/images/empresarial/notebook.svg";
import { ReactComponent as SprinklersIcon } from "../../../assets/images/empresarial/sprinklers.svg";
import { ReactComponent as AutoIcon } from "../../../assets/images/empresarial/auto.svg";
import { ReactComponent as LuckyIcon } from "../../../assets/images/empresarial/lucky.svg";
import { ReactComponent as FloodingIcon } from "../../../assets/images/empresarial/flooding.svg";

import { CommonFAQ } from "./BusinessCommon.constants";

export const LotteryAdvantageList = [
  {
    id: 1,
    icon: BuildingIcon,
    title: "Para quem?",
    description:
      "Exclusivo para mais de 20 mil lotéricas e Correspondentes Caixa Aqui (CCAs), que levam serviços e produtos da Caixa pelo Brasil.",
  },
  {
    id: 2,
    icon: TrophyIcon,
    title: "Vantagens",
    description:
      "Análise de pedidos em até 72h na cobertura de roubo de valores. Permite adicionar outras coberturas.",
  },
  {
    id: 3,
    icon: PinIcon,
    title: "Assistência 24h",
    description:
      "Inclui serviços emergenciais, como chaveiro e eletricista, para resolver os imprevistos do dia a dia, seja na empresa ou na casa do sócio.",
  },
];

export const LotteryCoverageList01 = [
  {
    id: 1,
    icon: ExplosionIcon,
    title: "Incêndio, queda de raio e explosão",
    description:
      "Cobre danos à empresa nessas situações, desde que ocorram dentro do terreno ou prédio onde estão os bens segurados, com sinais claros do que aconteceu.",
  },
  {
    id: 2,
    icon: CautionIcon,
    title:
      "Roubo de valores em trânsito ou roubo de valores no  estabelecimento",
    description: (
      <>
        Cobertura para roubo ou furto de valores em trânsito, que estejam em
        mãos de funcionários responsáveis, ou guardados em cofre-forte/guichês.
        Válida apenas para valores relacionados às atividades administradas ou
        controladas pela Caixa e sob a responsabilidade do segurado.
      </>
    ),
  },
];

export const LotteryCoverageList02 = [
  {
    id: 1,
    icon: ExplosionIcon,
    title:
      "Vendaval, furacão, tornado, granizo, impacto de veículos terrestres e queda de aeronave ",
    description: (
      <>
        Se a empresa sofrer danos causados por eventos climáticos severos, como
        vendaval, furacão, ciclone, tornado e chuva de granizo, os prejuízos
        serão cobertos. Essa cobertura inclui também quedas de aeronave entre
        outros objetos aéreos ou espaciais, além de colisões de carro, moto e
        caminhão, que danifiquem as instalações do negócio.
      </>
    ),
  },
  {
    id: 2,
    icon: CautionIcon,
    title:
      "Danos elétricos com cobertura para equipamentos, sistemas e componentes eletrônicos",
    description: (
      <>
        A rede elétrica da empresa sofreu superaquecimento ou curto-circuito?
        Nosso seguro garante indenização caso o problema elétrico danifique os
        computadores, câmeras de segurança, sistemas de acesso, alarme, cabos de
        energia e baterias, entre outros.
      </>
    ),
  },
  {
    id: 3,
    icon: TheftIcon,
    title: "Roubo de máquinas móveis e utensílios",
    description: (
      <>
        Caso as máquinas, os móveis e utensílios essenciais para o funcionamento
        do negócio sejam roubados ou furtados, a indenização será paga de acordo
        com o previsto na apólice.
      </>
    ),
  },
  {
    id: 4,
    icon: StrikeIcon,
    title: "Diárias de paralisação",
    description: (
      <>
        O seu negócio sofreu com a interrupção total ou parcial das atividades
        por mais de 5 dias? O pagamento das contas de água e luz estão
        garantidos, caso a paralisação seja causada por incêndio, raio ou
        explosão.
      </>
    ),
  },
  {
    id: 5,
    icon: RiotIcon,
    title: "Tumulto, greve e lockout",
    description: (
      <>
        Garante cobertura para perdas e danos materiais causados à empresa por
        aglomerações de pessoas que gerem perturbação (tumulto), paralisação de
        funcionários (greve) ou interrupção das atividades da empresa por
        decisão do empregador (lockout).
      </>
    ),
  },
  {
    id: 6,
    icon: GlassIcon,
    title: "Quebra de vidros e anúncios luminosos",
    description: (
      <>
        Indenização pelos prejuízos causados aos vidros e anúncios luminosos
        (letreiros) fixamente instalados na empresa.
      </>
    ),
  },
  {
    id: 7,
    icon: MoneyIcon,
    title: "Perda e pagamento de aluguel",
    description: (
      <>
        Se for preciso desocupar o imóvel onde a empresa funciona por conta de
        uma situação coberta pelo seguro, há reembolso dos aluguéis pagos ou não
        recebidos. A cobertura é válida em casos de explosão, incêndio, queda de
        raio, entre outros desastres naturais previstos na apólice, e impacto de
        veículos terrestres, como carro, moto e caminhão, que impeçam o
        funcionamento do negócio.
      </>
    ),
  },
  {
    id: 8,
    icon: NotebookIcon,
    title: "Equipamentos móveis e estacionários ",
    description: (
      <>
        A cobertura vale para acidentes de causa externa, como batidas de
        veículos durante o transporte do equipamento, queda de raio, entre
        outras situações previstas na apólice do seguro. Indeniza, até o valor
        máximo contratado, os prejuízos aos equipamentos da empresa que podem
        ser movidos com facilidade e os estacionários (fixos) que são mais
        difíceis de transportar. Exemplos: computadores, ferramentas, geradores
        e máquinas industriais.
      </>
    ),
  },
  {
    id: 9,
    icon: SprinklersIcon,
    title: "Derrame de sprinklers",
    description: (
      <>
        Garante reembolso para reparar danos à empresa causados por infiltração
        ou liberação acidental de água presente em instalações de chuveiros
        automáticos (sprinklers) de combate a incêndios.
      </>
    ),
  },
  {
    id: 10,
    icon: AutoIcon,
    title: "Guarda de veículos",
    description: (
      <>
        Cobre roubo e danos a veículos de terceiros que estejam sob a
        responsabilidade da empresa, ocorridos no local de risco indicado na
        apólice do seguro. A empresa deve apresentar o controle de entrada e
        saída do veículo que comprove a guarda do bem durante o incidente.
      </>
    ),
  },
  {
    id: 11,
    icon: LuckyIcon,
    title: "RC Operações lotérico",
    description: (
      <>
        Cobre os prejuízos que a empresa precise arcar, por decisão da Justiça,
        causados por acidentes relacionados ao uso e à conservação do imóvel, às
        atividades comerciais e industriais, bem como danos a terceiros
        decorrentes de incidentes envolvendo painéis de propaganda, letreiros e
        anúncios fixados no local segurado.
      </>
    ),
  },
  {
    id: 13,
    icon: FloodingIcon,
    title: "Alagamento e Inundação",
    description: (
      <>
        Cobre prejuízos aos bens segurados da empresa que forem atingidos por
        chuvas intensas, como aguaceiros e{" "}
        <span style={{ whiteSpace: "nowrap" }}>trombas d´água.</span>
      </>
    ),
  },
];

export const LotteryfaqList = [
  {
    title: "O que pode ser coberto pelo seguro?",
    body: (
      <>
        O seguro possui coberturas fixas, que são uma exigência da Caixa. Você
        escolhe a cobertura de Roubo de Valores em Trânsito ou Roubo de Valores
        no Estabelecimento. Além dessas, a cobertura para Incêndio, queda de
        raio e explosão também também é fixa. Possuímos outras opções que podem
        ser contratadas no Seguro Empresarial Lotérico e CCA.
      </>
    ),
  },
  {
    title: "É possível acionar assistência para a minha residência?",
    body: (
      <>
        Se vocè é o titular da empresa e o responsável pela apólice, é possível
        acionar a assistência para a sua residência.
      </>
    ),
  },
  {
    title: "Qual número para acionar um sinistro?",
    body: <>Assistência e Sinistros - 0800 274 1000.</>,
  },
  ...CommonFAQ,
];

export const LotteryDocumentList = [
  {
    id: 1,
    label: "Condições Gerais Seguro Lotérico/CCA - 2025",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Empresarial/CondicoesGerais/Condicoes-Gerais-Seguro-Loterico-e-CCA-2025.pdf",
  },
  {
    id: 2,
    label: "Condições Gerais Seguro Empresarial - 2023",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Empresarial/CondicoesGerais/Condicoes-Gerais-Seguro-Empresarial-2023.pdf",
  },
  {
    id: 3,
    label: "Condições Gerais Seguro Empresarial - 2021",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Empresarial/CondicoesGerais/Condicoes-Gerais-Seguro-Empresarial-2021.pdf",
  },
  {
    id: 5,
    label: "Manual de Assistência para o Estabelecimento - 2025",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Empresarial/Manuais/Manual-de-Assistencia-para-Estabelecimento-2025.pdf",
  },
  {
    id: 4,
    label: "Manual de Assistência Residencial - 2025",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Empresarial/Manuais/Manual-de-Assistencia-Residencial-2025.pdf",
  },
  {
    id: 6,
    label: "Manual de Assistência Funeral - 2025",
    href:
      "https://cdn.caixaseguradora.com.br/AreaAberta/Empresarial/Manuais/Manual-de-Assistencia-Funeral-2025.pdf",
  },
];
